import { useBusinessVertical } from "./use-business-vertical";
import { getVerticalConfig, type VerticalConfig } from "@/vertical/vertical-config";

/**
 * The active business's full vertical config (GRA-167): nav slot, Översikt
 * KPI card set + banner, Medarbetare variant column and recommended action
 * kinds, in one place. Views read this instead of branching on
 * `isDvhBusiness`/`vertical === "dvh"` themselves.
 */
export function useVerticalConfig(): VerticalConfig {
  const vertical = useBusinessVertical();
  return getVerticalConfig(vertical);
}
